import { render, staticRenderFns } from "./vinBtn.vue?vue&type=template&id=e557cf38&scoped=true&"
import script from "./vinBtn.vue?vue&type=script&lang=js&"
export * from "./vinBtn.vue?vue&type=script&lang=js&"
import style0 from "./vinBtn.vue?vue&type=style&index=0&id=e557cf38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e557cf38",
  null
  
)

export default component.exports